<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <form class="forms-sample" ref="anyName" @submit.stop.prevent="onSubmit" autocomplete="off">
            <div class="row mt-5">
                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                    <div class="row flex-grow">
                        <div class="col-12 grid-margin">
                            <div class="card">
                                <div class="card-header">
                                    <h4  v-if="!this.form.VendorID" class="card-title">Add Vendors</h4>
                                    <h4  v-if="this.form.VendorID" class="card-title">Update Vendors</h4>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6">
                                            <!-- <h4 class="text-center">Member</h4> -->
                                            <b-form-group label="Vendor Name" label-for="VendorName">
                                                <b-form-input type="text" id="VendorName" name="VendorName"
                                                    autocomplete="VendorName" placeholder="Vendor Name"
                                                    v-model="$v.form.VendorName.$model"
                                                    :state="$v.form.VendorName.$dirty ? !$v.form.VendorName.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <!-- <h4 class="text-center">Practice</h4> -->
                                            <b-form-group label="Vendor URL" label-for="VendorURL">
                                                <b-form-input type="text" id="VendorURL" name="VendorURL"
                                                    autocomplete="VendorURL" placeholder="VendorURL"
                                                    v-model="$v.form.VendorURL.$model"
                                                    :state="$v.form.VendorURL.$dirty ? !$v.form.VendorURL.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6">
                                            <b-form-group label="Phone No" label-for="PhoneNo">
                                                <b-form-input type="text" id="PhoneNo" name="VendorPhone"
                                                    autocomplete="VendorPhone" placeholder="Phone"
                                                    v-model="$v.form.VendorPhone.$model"
                                                    :state="$v.form.VendorPhone.$dirty ? !$v.form.VendorPhone.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <b-form-group label="Vendor Order" label-for="VendorOrder">
                                                <b-form-input type="number" id="VendorOrder" name="VendorOrder"
                                                    autocomplete="VendorOrder" placeholder="Vendor Order"
                                                    v-model="$v.form.VendorOrder.$model"
                                                    :state="$v.form.VendorOrder.$dirty ? !$v.form.VendorOrder.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3 col-sm-6">
                                            <b-form-group class="vendor-active" label="Active" label-for="Active">
                                                <b-form-checkbox id="Active" name="Active" value="1" unchecked-value="0"
                                                    v-model="form.Active" aria-describedby="input-1-live-feedback">
                                                </b-form-checkbox>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6"></div>
                                        <div class="col-md-6 mt-3">
                                            <b-button type="submit" variant="success" :disabled="isDisabled"
                                                class="btn float-right btn-success">
                                                <span v-if="!this.form.VendorID">Submit</span>
                                                <span v-if="this.form.VendorID">Update</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <!--                                </form>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
// import Snotify, { SnotifyPosition } from 'vue-snotify'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";

// const options = {
//     toast: {
//         position: SnotifyPosition.rightTop,
//     },
//     global:{
//         maxOnScreen: 1,
//         preventDuplicates:true,
//         oneAtTime:true
//     }
// }
// Vue.use(Snotify, options)
export default {
    name: 'Users',
    mixins: [validationMixin],
    data() {
        return {
            form: {
                VendorID: '',
                VendorName: '',
                VendorOrder: '',
                VendorURL: '',
                VendorPhone: '',
                Active: '',
            },

            isDisabled: false,
            readonly: true,
            member: {},
        };
    },
    validations: {
        form: {
            VendorName: {
                required,
            },
            VendorURL: {
                required,
            },
            VendorPhone: {
                required,
            },
            VendorOrder: {
                required,
            },
        }
    },
    mounted() {
        this.editMember();
    },
    methods: {
        onSubmit() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.isDisabled = true;
            API.addUpdateVendor(this.form,
                data => {
                    this.isDisabled = false;
                    if (!this.form.VendorID) {
                        if (data.status === 410) {
                            this.$showNotification({ message: 'target resource is no longer available' }, "error")

                        } else {
                            this.$showNotification({ message: 'User created Successfully' }, "success")
                            this.submitForm();
                        }
                    } else {
                        this.$showNotification({ message: 'Vendor added Successfully' }, "success")
                        this.submitForm();
                    }
                    this.$router.push({name:"ViewVendors"})
                },
                err => {
                    this.isDisabled = false;
                    this.$showNotification({ message: 'Failed system error' }, "error")
                }
            )
        },
        editMember() {
            if (this.$route.params.user) {
                this.form = this.$route.params.user;
            } 
        },
        submitForm() {
            this.$refs.anyName.reset();
        },

    }, computed: {},
}
</script>
